import { atom } from "recoil";

// Auth data received from login / validate_token API
export const modulesRecoilVar = atom({
  key: "modulesRecoilVar",
  default: null,
});
